import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function Cart(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 4h17a1 1 0 01.976 1.217L19.901 14H8.1l-2-9H4a1.342 1.342 0 00-.152.017 1.344 1.344 0 00-.374.118.818.818 0 00-.324.275C3.07 5.53 3 5.712 3 6s.07.47.15.59a.818.818 0 00.324.275A1.344 1.344 0 004 7h.003A.5.5 0 014 8h-.034L3.9 7.995a2.343 2.343 0 01-.874-.236 1.816 1.816 0 01-.708-.615C2.118 6.843 2 6.462 2 6c0-.462.117-.843.318-1.145.2-.298.462-.491.708-.615a2.343 2.343 0 01.874-.236L4 4zm3.123 1l1.778 8H19.1L21 5H7.123zM12 18a2 2 0 11-4 0 2 2 0 014 0zm-1 0a1 1 0 11-2 0 1 1 0 012 0zM18 20a2 2 0 100-4 2 2 0 000 4zm0-1a1 1 0 100-2 1 1 0 000 2z",
    clipRule: "evenodd"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Cart);
export default ForwardRef;